(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'prop-types'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.propTypes);
        global.ImageShape = mod.exports;
    }
})(this, function (exports, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = _propTypes2.default.shape({
        alt: _propTypes2.default.string,
        src: _propTypes2.default.string.isRequired,
        srcSet: _propTypes2.default.string,
        sizes: _propTypes2.default.string,
        width: _propTypes2.default.number.required,
        height: _propTypes2.default.number.required
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/ImageShape.js
 ** module id = 221
 ** module chunks = 0
 **/